export default "__VITE_ASSET__hzQGS9CA__"